import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';
import type {
  ExecutiveDashboardFilter, ExecutiveDashboardDto,
  ProfitabilityFilter, ProfitabilityDto,
  ExpenseAnalysisFilter, ExpenseAnalysisDto,
  CostCentrePerformanceFilter, CostCentrePerformanceDto,
  FinancialTrendFilter, FinancialTrendDto,
  AccountActivityFilter, AccountActivityDto,
  JournalAnalysisFilter, JournalAnalysisDto,
  FinancialScorecardFilter, FinancialScorecardDto,
} from '@/types/analytics.types';

export const analyticsApi = {
  /** GET /api/v1/analytics/executive-dashboard */
  getExecutiveDashboard: (filter: ExecutiveDashboardFilter) =>
    apiClient.get<ApiResponse<ExecutiveDashboardDto>>('/analytics/executive-dashboard', { params: filter }),

  /** GET /api/v1/analytics/profitability */
  getProfitability: (filter: ProfitabilityFilter) =>
    apiClient.get<ApiResponse<ProfitabilityDto>>('/analytics/profitability', { params: filter }),

  /** GET /api/v1/analytics/expense-analysis */
  getExpenseAnalysis: (filter: ExpenseAnalysisFilter) =>
    apiClient.get<ApiResponse<ExpenseAnalysisDto>>('/analytics/expense-analysis', { params: filter }),

  /** GET /api/v1/analytics/cost-centre-performance */
  getCostCentrePerformance: (filter: CostCentrePerformanceFilter) =>
    apiClient.get<ApiResponse<CostCentrePerformanceDto>>('/analytics/cost-centre-performance', { params: filter }),

  /** GET /api/v1/analytics/financial-trend */
  getFinancialTrend: (filter: FinancialTrendFilter) =>
    apiClient.get<ApiResponse<FinancialTrendDto>>('/analytics/financial-trend', { params: filter }),

  /** GET /api/v1/analytics/account-activity */
  getAccountActivity: (filter: AccountActivityFilter) =>
    apiClient.get<ApiResponse<AccountActivityDto>>('/analytics/account-activity', { params: filter }),

  /** GET /api/v1/analytics/journal-analysis */
  getJournalAnalysis: (filter: JournalAnalysisFilter) =>
    apiClient.get<ApiResponse<JournalAnalysisDto>>('/analytics/journal-analysis', { params: filter }),

  /** GET /api/v1/analytics/scorecard */
  getScorecard: (filter: FinancialScorecardFilter) =>
    apiClient.get<ApiResponse<FinancialScorecardDto>>('/analytics/scorecard', { params: filter }),
};
